import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { CLIENT_LOGOUT } from '@pass-frontend/common/data-access';
import { IMutation } from '@pass-frontend/data-access/common/edge';

export const useClientLogout = () => {
  const [clientLogout] =
    useMutation<Pick<IMutation, 'clientLogout'>>(CLIENT_LOGOUT);

  const handleClientLogout = useCallback(() => {
    return clientLogout();
  }, [clientLogout]);

  return {
    handleClientLogout,
  };
};
